export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6377.067c2e0a.jpg";